import { takeLatest, put, call, select } from 'redux-saga/effects';
import { apiRequest } from '../../apiRequest';
import { URLs } from '../../urls';

import { CreateSurveyActionsTypes, ICreateSurveyResult, CreateSurveyRequestSucces, CreateSurveyRequestError
} from './types';

const id = localStorage.getItem("UserId");

function* sendCreateSurveyRequest(action: any) {
	try {
		// API call
		const response : ICreateSurveyResult = yield call(apiRequest, {
			endpoint: URLs.CREATE_SURVEY_APP_ENDPOINT,
			method: 'POST',
			body: action.model
		});

		if (response.success == true) {
			let putData: CreateSurveyRequestSucces = {
				type: CreateSurveyActionsTypes.POST_CREATE_SURVEY_APP_SUCCESS,
				data: response.data,
				loading: false,
				success: response.success
			};
			yield put<CreateSurveyRequestSucces>(putData);
		}

		if (response.success == false) {
			let putData: CreateSurveyRequestError = {
				type: CreateSurveyActionsTypes.POST_CREATE_SURVEY_APP_ERROR,
				error: response.error.toString(),
				loading: false
			};
			yield put<CreateSurveyRequestError>(putData);
		}

	} catch (e: any) {
		let putData: CreateSurveyRequestError = {
			type: CreateSurveyActionsTypes.POST_CREATE_SURVEY_APP_ERROR,
			error: e,
			loading: false
		};
		yield put<CreateSurveyRequestError>(putData);
	}
}

export function* handler() {
	yield takeLatest(CreateSurveyActionsTypes.POST_CREATE_SURVEY_APP, sendCreateSurveyRequest);
}

